/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentDelegatedGrant,
  AgentDelegatedGrant$inboundSchema,
} from "./agentdelegatedgrant.js";

export type AgentDelegatedPolicy = {
  effective: Array<AgentDelegatedGrant>;
  requested: Array<AgentDelegatedGrant>;
};

/** @internal */
export const AgentDelegatedPolicy$inboundSchema: z.ZodMiniType<
  AgentDelegatedPolicy,
  unknown
> = z.object({
  effective: z.array(AgentDelegatedGrant$inboundSchema),
  requested: z.array(AgentDelegatedGrant$inboundSchema),
});

export function agentDelegatedPolicyFromJSON(
  jsonString: string,
): SafeParseResult<AgentDelegatedPolicy, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentDelegatedPolicy$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentDelegatedPolicy' from JSON`,
  );
}
